import React from 'react';
import type { IconProps } from '../types';

export const NavigationPanelReveal = (props: IconProps) => (
  <svg
    width="20"
    height="14"
    viewBox="0 0 17 10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.856 5.078H1M5.078 1 1 5.078l4.078 4.078M15.582 9.156V1" />
    </g>
  </svg>
);

export default NavigationPanelReveal;
